import { render, staticRenderFns } from "./codePopup.vue?vue&type=template&id=134d8f52&scoped=true&"
import script from "./codePopup.vue?vue&type=script&lang=js&"
export * from "./codePopup.vue?vue&type=script&lang=js&"
import style0 from "./codePopup.vue?vue&type=style&index=0&id=134d8f52&prod&lang=css&"
import style1 from "./codePopup.vue?vue&type=style&index=1&id=134d8f52&prod&lang=scss&scoped=true&"
import style2 from "./codePopup.vue?vue&type=style&index=2&id=134d8f52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d8f52",
  null
  
)

export default component.exports